import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Header } from '../../../../../base/components/Header';
import {
    useAppDispatch,
    useAppSelector,
    useBrowserBackClickHandler,
    useHideWebsiteFooter,
} from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { SignUpStep } from '../../enums';
import { Footer } from '../../components/SignUp/Footer';
import { Confirmation } from '../../components/SignUp/Confirmation';
import { RegistrationInfo } from '../../components/SignUp/RegistrationInfo';
import { signUpActions } from '../../redux/slices/signUpSlice';
import { Helmet } from '../../../../components/Helmet';

export const SignUpPage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { step } = useAppSelector((state) => state.workerAppSignUp);
    const { referrer } = useAppSelector((state) => state.app);

    const [savedReferrerLocation, setSavedReferrerLocation] = useState('');

    useHideWebsiteFooter();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0 });

        return function () {
            dispatch(signUpActions.clearData());
        };
    }, []);

    useEffect(() => {
        if (location.state?.from?.pathname) {
            setSavedReferrerLocation(location.state?.from?.pathname);
        }
    }, [location]);

    const onBackClick = useCallback(() => {
        if (step === SignUpStep.RegistrationInfo) {
            if (savedReferrerLocation) {
                navigate(savedReferrerLocation);
                return;
            }
            if (referrer) {
                window.location.href = referrer;
                return;
            }
        }

        dispatch(signUpActions.setStep(step - 1));
    }, [step, referrer, savedReferrerLocation]);

    useBrowserBackClickHandler(onBackClick);

    const progressWidth = useMemo(() => {
        switch (step) {
            case SignUpStep.RegistrationInfo:
                return 66;
            case SignUpStep.Confirmation:
                return 100;
            default:
                return 0;
        }
    }, [step]);

    const stepContent = useMemo(() => {
        switch (step) {
            case SignUpStep.RegistrationInfo:
                return <RegistrationInfo />;
            case SignUpStep.Confirmation:
                return <Confirmation />;
            default:
                return null;
        }
    }, [step]);

    const nextLinkText = useMemo(() => {
        if (step === SignUpStep.Confirmation) {
            return __t('Зарегистрироваться');
        }

        return __t('Далее');
    }, [step]);

    const onNextClick = () => dispatch(signUpActions.submitSignUp());

    return (
        <>
            <Helmet pageName={__t('Регистрация')} />
            <div className='worker-signup-page'>
                <Header title={__t('Регистрация')} onBackClick={onBackClick} />
                <div className='worker-signup'>{stepContent}</div>;
                <Footer
                    backLinkText={__t('Назад')}
                    nextLinkText={nextLinkText}
                    progressWidth={progressWidth}
                    onBackClick={onBackClick}
                    onNextClick={onNextClick}
                />
            </div>
        </>
    );
};
